import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { to: '/#features', label: 'Features' },
    { to: '/#channels', label: 'Channels' },
    { to: '/#how', label: 'How it works' },
    { to: '/#pricing', label: 'Pricing' },
    { to: '/#faq', label: 'FAQ' },
  ];

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">
        <Link to="/" className="nav__brand" aria-label="AinaSuite home">
          <img
            src="/ainasuite_light_top.png"
            alt="AinaSuite"
            className="nav__brandImg"
          />
        </Link>

        <nav className="nav__links">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="nav__link">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="nav__cta">
          <a
            href="https://ai.ainasuite.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--ghost"
          >
            Sign in
          </a>
        </div>

        <button
          aria-label="Open menu"
          className="nav__burger"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="nav__mobile">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="nav__mobileLink"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </Link>
          ))}
          <div className="nav__mobileCta">
            <a
              href="https://ai.ainasuite.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--ghost btn--block"
            >
              Sign in
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
